import { render, staticRenderFns } from "./WizardNuevoMovimientoLogi.vue?vue&type=template&id=2c0988ce&scoped=true&"
import script from "./WizardNuevoMovimientoLogi.vue?vue&type=script&lang=js&"
export * from "./WizardNuevoMovimientoLogi.vue?vue&type=script&lang=js&"
import style0 from "./WizardNuevoMovimientoLogi.vue?vue&type=style&index=0&id=2c0988ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0988ce",
  null
  
)

export default component.exports